function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
const TabsContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = TabsContext;
class Tabs extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "setSelected", selected => {
      this.setState({
        selected
      });
    });
    this.state = {
      initialSelected: props.selected,
      selected: props.selected,
      handleSelect: this.setSelected
    };
  }
  static getDerivedStateFromProps(props, state) {
    return props.selected !== state.initialSelected ? {
      selected: props.selected
    } : null;
  }
  render() {
    return /*#__PURE__*/React.createElement(Provider, {
      value: this.state
    }, this.props.children);
  }
}
Tabs.propTypes = {
  /** Tab id of selected tab */
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Tabs.defaultProps = {};
Tabs.displayName = 'Tabs';
export default Tabs;
export { TabsContext };